import { useContext, useState, useEffect } from "react";
import { Context } from "../../components/Context";
import { Button, Modal, Table } from "react-bootstrap";
import { getUniqueSymbols } from "../../tools/utilities";
import { MultiSelectDropdown, ShowSelectedToggle, TrendToggle, SelectFilterStock } from "../../components/Form";



function Navbar() {
    const { contextData } = useContext(Context);
    const uniqueSymbols = getUniqueSymbols(contextData.rows)

    return (
        <div className="card mb-5" style={{ background: "#3B6CE9", borderRadius: "16px" }}>
            <div className="navbar-main justify-content-lg-between flex-wrap border-0  align-items-center  p-4"
                style={{ background: "#3B6CE9", borderRadius: "16px" }}>
                <div className="navbar-right mx-lg-2 mx-2 " dir="rtl">
                    <div className="navbar-right-search">
                        <MultiSelectDropdown buttonName="افزودن" symbols={uniqueSymbols} />
                        <SelectedSymbolsMenu />
                    </div>
                    <div className="navbar-right-filter">
                        <SelectFilterStock />
                    </div>
                </div>

                <div className="navbar-left d-flex justify-content-lg-end align-items-center justify-content-between" id="filterInput">
                    <div className="d-flex mx-2">
                        <ShowSelectedToggle />
                    </div>
                    <div className="d-flex mx-2 d-lg-none d-block">
                        <TrendToggle />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navbar

export function SelectedSymbolsMenu() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <Button variant="primary" onClick={handleShow}>
                <i className="las la-shopping-basket" style={{ fontSize: "24px", color: "#FFFFFF" }} />
            </Button>

            <Modal show={show} onHide={handleClose} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>نمادهای انتخاب شده</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <SelectedSymbolTable />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        خروج
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}


export function SelectedSymbolTable() {
    const [selectedSymbols, setSelectedSymbols] = useState([])
    const { updateSelectedSymbols } = useContext(Context);

    useEffect(() => {
        setSelectedSymbols(localStorage.getItem('selectedSymbols') ? JSON.parse(localStorage.getItem('selectedSymbols')) : [])
    }, []);
    const onClick = (event) => {
        const localStorageSymbols = localStorage.getItem('selectedSymbols') ? JSON.parse(localStorage.getItem('selectedSymbols')) : []
        const filteredList = localStorageSymbols.filter((item) => item.value !== event.target.id)
        setSelectedSymbols(filteredList)
        localStorage.setItem('selectedSymbols', JSON.stringify(filteredList));
        updateSelectedSymbols(filteredList)
    };


    return (
        <Table striped="columns" dir="rtl">
            <thead>
                <tr>
                    <th>نام نماد</th>
                    <th>عملیات</th>
                </tr>
            </thead>
            <tbody>
                {selectedSymbols.map((selectedSymbol, index) => (
                    <tr key={index}>
                        <td>{selectedSymbol.label}</td>
                        <td><span id={selectedSymbol.value} className="btn btn-sm" onClick={onClick}>حذف</span></td>
                    </tr>))}
            </tbody>
        </Table>
    )
}